import { subCompanyCompensationPlanApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const COMPENSATION_PLANS_ACTION_TYPE = createNamedActions('compensationPlans', {
  GET_PLANS: 'GET_PLANS',
  CREATE_PLAN: 'CREATE_PLAN',
  UPDATE_PLAN: 'UPDATE_PLAN',
  DELETE_PLAN: 'DELETE_PLAN',
  APPROVE_CHANGE: 'APPROVE_CHANGE',
  RESET_STATE: 'RESET_STATE',
});

export const getCompensationPlansAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await subCompanyCompensationPlanApi.getCompensationPlans(params);

  return dispatch({
    type: COMPENSATION_PLANS_ACTION_TYPE.GET_PLANS,
    payload: data,
  });
});

export const createCompensationPlanAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await subCompanyCompensationPlanApi.createCompensationPlan(params);

  return dispatch({
    type: COMPENSATION_PLANS_ACTION_TYPE.CREATE_PLAN,
    payload: data,
  });
});

export const updateCompensationPlanAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await subCompanyCompensationPlanApi.updateCompensationPlan(params);

  return dispatch({
    type: COMPENSATION_PLANS_ACTION_TYPE.UPDATE_PLAN,
    payload: data,
  });
});

export const deleteCompensationPlanAction = catchAsyncActionError(params => async dispatch => {
  await subCompanyCompensationPlanApi.deleteCompensationPlan(params);

  return dispatch({
    type: COMPENSATION_PLANS_ACTION_TYPE.DELETE_PLAN,
    payload: params.planId,
  });
});

export const approveCompensationPlanChangeAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await subCompanyCompensationPlanApi.approveChange(params);

    return dispatch({
      type: COMPENSATION_PLANS_ACTION_TYPE.APPROVE_CHANGE,
      payload: data,
    });
  },
);
